module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/questionnaire-section/questionnaire-section.scss
// module id = ./web/modern/components/settings/questionnaire-section/questionnaire-section.scss
// module chunks = 0